import styled, { css } from 'styled-components';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { alpha, getSpacingToken, getToken } from '@optimus-web/core';

interface EmptyElementProps {
    textAlign: 'center' | 'left' | 'right';
    padded?: boolean;
    display: 'block' | 'inline';
}

const EmptyElement = styled.div<EmptyElementProps>`
    color: ${({ theme }) => alpha(getToken('paletteBrandNight1000')({ theme }), getToken('opacity800')({ theme }))};
    font-size: 16px;
    font-weight: 400;
    font-style: italic;
    display: ${(props) => props.display};
    text-align: ${(props) => props.textAlign};

    ${(props) =>
        props.padded === true &&
        css`
            padding: ${getSpacingToken('200')}px;
        `}
`;

interface EmptyProps extends Partial<EmptyElementProps> {
    textKey?: Mews.TextKey;
}

export const Empty = ({
    textKey = TextKey.NoDataAvailable,
    textAlign = 'center',
    padded = false,
    display = 'block',
}: EmptyProps) => (
    <EmptyElement textAlign={textAlign} display={display} padded={padded}>
        <LocalizedText textKey={textKey} />
    </EmptyElement>
);
